import { persist, createSessionStorage, createLocalStorage, } from "@macfja/svelte-persistent-store";
import { writable } from "svelte/store";
export const warningModalOpen = writable(false);
export const token = writable("");
export const refreshToken = writable("");
export const errorMessage = writable("");
export const successMessage = writable("");
export const loading = writable(false);
export const loadingSort = writable(false);
export const loadingDownload = writable(false);
export const userRole = persist(writable([]), createLocalStorage(), "userRole");
export const userName = persist(writable(""), createLocalStorage(), "userName");
export const email = persist(writable(""), createLocalStorage(), "email");
export const sizeSelect = persist(writable("20"), createSessionStorage(), "sizeSelect");
export const totalPages = writable(1);
export const totalRecords = writable(0);
export const modalOpen = writable(false);
export const canvasOpen = writable(false);
export const userId = writable("");
export const groupId = writable("");
export const carData = writable("");
export const blackoutCarData = writable("");
export const createBlackoutData = writable("");
export const editData = writable("");
export const carDetail = persist(writable(""), createSessionStorage(), "carDetail");
export const DynamicComponent = writable(1);
export const vehicleId = writable("");
export const issueDetail = persist(writable(""), createSessionStorage(), "issueDetail");
export const loadSpinner = writable(false);
export const imageLightbox = writable([]);
export const imageShowingIndex = writable(0);
export const masterData = persist(writable([]), createLocalStorage(), "masterData");
export const evMasterData = persist(writable([]), createLocalStorage(), "evMasterData");
export const carSelection = writable([]);
export const trigerBlackoutSearch = writable(false);
export const switchBlackout = writable(0);
export const editBlackoutData = persist(writable({
    id: "",
    stats: false,
}), createSessionStorage(), "editBlackoutData");
export const initialEditBlackout = writable(0);
export const carParkPostal = persist(writable(""), createSessionStorage(), "carParkPostal");
export const carparkDetail = persist(writable(""), createSessionStorage(), "carparkDetail");
export const loadingStatus = writable(false);
export const vehicleEditData = writable("");
export const efficiencyEditData = persist(writable(""), createSessionStorage(), "efficiencyEditData");
export const fetchGroupModal = writable(false);
export const carIssueOpen = writable(false);
export const issueNumber = writable("");
export const carIssueData = writable("");
export const resolveIssue = writable({
    issueId: "",
    isResolving: false,
});
export const isResolvingIssue = writable(false);
export const initPage = persist(writable(1), createSessionStorage(), "initPage");
export const availabilityData = writable([]);
export const fetchIssueModal = writable(false);
export const bookingId = writable("");
export const LoadingFetch = writable(false);
export const vehicleCurrentPage = writable(1);
export const pendingIssueCarSection = writable("");
export const currentCarSection = writable("");
export const editFuelcardData = writable({});
export const editEvData = writable({});
export const fmsUserDetailData = writable({});
export const CPOEditData = persist(writable(""), createSessionStorage(), "cpoDetail");
export const evLogIds = persist(writable([]), createSessionStorage(), "evLogIds");
export const isEvLogOpen = writable(false);
export const jobAction = writable("");
export const jobId = writable("");
export const toastMessage = writable({
    message: "",
    type: "",
});
export const csvError = writable(false);
export const csvErrorData = writable([]);
export const activeTableHasError = writable(true);
export const assignState = writable(false);
export const canAssign = writable(false);
export const assignableTasks = writable([]);
export const cachedTaskLookups = persist(writable(null), createSessionStorage(), "cachedTaskLookups");
export const cachedJobLookups = persist(writable(null), createSessionStorage(), "cachedJobLookups");
export const damageReviewed = persist(writable(false), createSessionStorage(), "damageReviewed");
export const damageReviewedData = persist(writable([]), createLocalStorage(), "damageReviewedData");
